import queryClient from './queryClient';
import { currentUserQuery } from './queries';
import type { User } from './models';

// eslint-disable-next-line import/prefer-default-export
export async function currentUser(): Promise<User> {
  const { data } = await queryClient.ensureQueryData(currentUserQuery(true));

  return data;
}
